import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IRespondent } from '../../models/data-capture.models';

interface IGroupedSegment {
  segmentId: string;
  segmentName: string;
  respondents: (IRespondent & { checked: boolean })[];
  checked: boolean;
}

@Component({
  selector: 'app-sheet-filter',
  templateUrl: './sheet-filter.component.html',
  styleUrls: ['./sheet-filter.component.scss'],
  standalone: false,
})
export class SheetFilterComponent implements OnInit {
  segmentLists: IGroupedSegment[] = [];

  constructor(
    private dialogRef: MatDialogRef<SheetFilterComponent>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      respondents: IRespondent[];
      selectedRespondentIds?: string[];
    }
  ) {}

  ngOnInit() {
    const segmentIdDict = this.data.respondents.reduce<
      Record<string, IRespondent[]>
    >(
      (acc, respondent) => ({
        ...acc,
        [respondent.opportunitySegmentId]: [
          ...(acc[respondent.opportunitySegmentId] || []),
          respondent,
        ],
      }),
      {}
    );

    this.segmentLists = Object.entries(segmentIdDict).map<IGroupedSegment>(
      ([segmentId, respondents]) => {
        const mappedRespondents = respondents.map((respondent) => ({
          ...respondent,
          checked: this.data.selectedRespondentIds
            ? this.data.selectedRespondentIds.includes(respondent.respondentId)
            : true,
        }));

        return {
          segmentId,
          segmentName: `${respondents[0].geography} - ${respondents[0].segment}`,
          respondents: mappedRespondents,
          checked: mappedRespondents.some((respondent) => respondent.checked),
        };
      }
    );
  }

  toggleSegment(segment: IGroupedSegment) {
    segment.respondents.forEach((respondent) => {
      respondent.checked = segment.checked;
    });
  }

  updateSegmentChecked(segment: IGroupedSegment) {
    segment.checked = segment.respondents.every(
      (respondent) => respondent.checked
    );
  }

  submit() {
    const selectedIds = this.segmentLists
      .flatMap((s) => s.respondents)
      .filter((respondent) => respondent.checked)
      .map((respondent) => respondent.respondentId);

    this.dialogRef.close(selectedIds);
  }
}
